function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LeagueRankingsTemplate = require('./rankings.template');
//const LeagueOverlay = require("./overlays/league");
var LeagueRankings = /*#__PURE__*/function () {
  function LeagueRankings(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, LeagueRankings);
    this.app = app;
    this.mod = mod;
    this.container = container;
    //Currently being defined by module
    //this.overlay = new LeagueOverlay(this.app, this.mod);

    app.connection.on('league-rankings-render-request', function () {
      if (_this.mod.debug) {
        console.info('league-rankings-render-request');
      }
      _this.render();
    });
  }
  return _createClass(LeagueRankings, [{
    key: "render",
    value: function render() {
      //
      // insert content we will render into
      //
      if (document.querySelector('.league-rankings')) {
        this.app.browser.replaceElementBySelector(LeagueRankingsTemplate(), '.league-rankings');
      } else {
        this.app.browser.addElementToSelector(LeagueRankingsTemplate(), this.container);
      }

      //
      // add content to league rankings
      //
      var leagues = this.mod.leagues.slice();
      leagues.sort(function (a, b) {
        if (a.rank <= 0 && b.rank <= 0) {
          return 0;
        }
        if (a.rank <= 0) {
          return 1;
        }
        if (b.rank <= 0) {
          return -1;
        }
        return a.rank - b.rank;
      });
      var html = '';
      if (leagues.length > 0) {
        var cnt = 0;
        leagues.forEach(function (l) {
          html += "<div data-id=\"".concat(l.id, "\" data-game=\"").concat(l.game, "\" class=\"saito-table-row league-leaderboard-ranking\">\n\t\t\t              <div class=\"saito-table-gamename\">").concat(l.name, "</div>");
          if (l.rank > 0) {
            html += "<div class=\"saito-table-rank\">".concat(l.rank, "</div></div>");
          } else {
            html += "<div class=\"saito-table-rank saito-deemphasize\">\u2026</div></div>";
          }
        });
      }
      this.app.browser.addElementToSelector(html, '.league-rankings  .saito-table-body');
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelectorAll('.league-leaderboard-ranking').forEach(function (el) {
        el.onclick = function (e) {
          e.preventDefault();
          _this2.app.connection.emit('arcade-game-info-render-request', {
            leagueId: e.currentTarget.getAttribute('data-id'),
            game: e.currentTarget.getAttribute('data-game')
          });
        };
      });
    }
  }]);
}();
module.exports = LeagueRankings;